import { isMyMessage, sendMessageNotification } from "../libs/services";
import { ChannelSendMessage, ChannelSendMessageResponse } from "../proto/ChannelSendMessage_pb";
import { ChatSendMessage, ChatSendMessageResponse } from "../proto/ChatSendMessage_pb";
import { Room, RoomMessage, RoomMessageStatus } from "../proto/Global_pb";
import { GroupSendMessage, GroupSendMessageResponse } from "../proto/GroupSendMessage_pb";
import store from "../store";
import { addRoomMessages, removeRoomMessage } from "../store/messages/actions";
import { addRooms, editRoom } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";
import { protoHandler } from "../libs/proto";
import { CHAT_UPDATE_STATUS, CLIENT_GET_ROOM, GROUP_UPDATE_STATUS } from "../constants/methods";
import { getStorage } from "../libs/storage";
import { STORAGE_CURRENT_ROOM } from "../constants/localstorage";

export default class HandleRoomSendMessageResponse extends BaseHandler<
  GroupSendMessageResponse | ChannelSendMessageResponse | ChatSendMessageResponse,
  GroupSendMessage | ChannelSendMessage | ChatSendMessage
> {
  private room?: Room.AsObject;
  private message?: RoomMessage.AsObject;

  private deleteCreatedFakeMessage(): void {
    const roomSendMessageRequest = this.request?.toObject();

    if (roomSendMessageRequest !== undefined) {
      /* Delete created Fake Message */
      store.dispatch(
        removeRoomMessage({
          roomId: roomSendMessageRequest.roomId,
          messageId: roomSendMessageRequest.randomId,
        })
      );
    }
  }

  private handleLastMessage(): void {
    const roomSendMessageResponse = this.response.toObject();
    const isCurrentRoom = this.room?.id === getStorage(STORAGE_CURRENT_ROOM);

    let updatedRoom: Partial<Room.AsObject> = {
      lastMessage: roomSendMessageResponse.roomMessage,
    };
    if (!isMyMessage(roomSendMessageResponse.roomMessage)) {
      updatedRoom = {
        ...updatedRoom,
        unreadCount: (this.room?.unreadCount || 0) + 1,
        // firstUnreadMessage: find(store.getState().messages.messages, (m) => !includes([RoomMessageStatus.LISTENED, RoomMessageStatus.SEEN], m.status)),
        firstUnreadMessage: isCurrentRoom ? undefined : this.room?.firstUnreadMessage || roomSendMessageResponse.roomMessage,
      };
    }
    store.dispatch(
      editRoom({
        roomId: roomSendMessageResponse.roomId,
        room: updatedRoom,
      })
    );
  }

  private goToMessage() {
    const scrollElement = document.getElementById("messages_scrollBar");
    if (scrollElement) scrollElement.scrollTop = 0;
  }

  handle() {
    const roomSendMessageResponse = this.response.toObject();

    if (roomSendMessageResponse.roomMessage === undefined) return;

    this.message = roomSendMessageResponse.roomMessage;
    this.room = store.getState().rooms.rooms[roomSendMessageResponse.roomId];

    this.deleteCreatedFakeMessage();

    if (this.room === undefined) {
      protoHandler(CLIENT_GET_ROOM, { roomId: roomSendMessageResponse.roomId }).then((roomResponse: any) => {
        if (roomResponse?.room) addRooms([roomResponse.room]);
      });
    } else this.handleLastMessage();

    store.dispatch(
      addRoomMessages({
        roomId: roomSendMessageResponse.roomId,
        messageList: [roomSendMessageResponse.roomMessage],
      })
    );

    const { currentRoom } = store.getState().rooms;
    if (currentRoom === this.room?.id && isMyMessage(roomSendMessageResponse.roomMessage)) this.goToMessage();

    if (this.room.id !== getStorage(STORAGE_CURRENT_ROOM)) {
      protoHandler(this.room.type === Room.Type.CHAT ? CHAT_UPDATE_STATUS : GROUP_UPDATE_STATUS, {
        messageId: this.message.messageId,
        roomId: roomSendMessageResponse.roomId,
        status: RoomMessageStatus.DELIVERED,
      }).then();
    }

    sendMessageNotification(roomSendMessageResponse.roomId, this.room, roomSendMessageResponse.roomMessage);
  }
}
